import { render, staticRenderFns } from "./LimitedAccessBanner.vue?vue&type=template&id=10becd62&scoped=true&"
import script from "./LimitedAccessBanner.vue?vue&type=script&lang=js&"
export * from "./LimitedAccessBanner.vue?vue&type=script&lang=js&"
import style0 from "./LimitedAccessBanner.vue?vue&type=style&index=0&id=10becd62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10becd62",
  null
  
)

export default component.exports